var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManuscriptBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 23.5h11m-11-4h11m-11-4.583h11M33 28v3a3 3 0 0 1-2.824 2.995L30 34H13v-.171A3.001 3.001 0 0 0 15 31v-3h18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28V10H11v20.427C11 32.4 12.343 34 14 34h1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuscriptBtn);
export default __webpack_public_path__ + "static/media/manuscriptBtn.edf403c0f1f551e5333e5b55194175b6.svg";
export { ForwardRef as ReactComponent };